import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myWorksheets, myQuizzes, myReflections, myPart2, downloadJourneyPdf, collectLocalAnswers } from "@/lib/api";

function Stat({ label, value }) {
  return (
    <div className="rbl-card" style={{ alignItems: "flex-start" }}>
      <span className="rbl-card-num">{label.toUpperCase()}</span>
      <span style={{ fontSize: 36, fontWeight: 800, color: "var(--navy)" }}>{value}</span>
    </div>
  );
}

export default function PDashboard() {
  const { user, lang } = useApp();
  const t = useAppUi(lang);
  const [ws, setWs] = useState([]);
  const [qz, setQz] = useState([]);
  const [refs, setRefs] = useState([]);
  const [busy, setBusy] = useState(false);
  const [part2, setPart2] = useState(false);

  useEffect(() => {
    myPart2().then((d) => setPart2(!!d.access)).catch(() => {});
    myWorksheets().then(setWs).catch(() => {});
    myQuizzes().then(setQz).catch(() => {});
    myReflections().then(setRefs).catch(() => {});
  }, []);

  const wsDone = ws.filter((w) => w.submission).length;
  const qzDone = qz.filter((q) => q.attempt).length;

  const downloadJourney = async () => {
    setBusy(true);
    try {
      await downloadJourneyPdf({ name: user?.full_name || "", answers: collectLocalAnswers(), lang });
    } finally { setBusy(false); }
  };

  return (
    <PLayout>
      <div className="rbl-eyebrow">{t("appKicker")}</div>
      <h1 className="rbl-h1" style={{ fontSize: 40 }} data-testid="dashboard-welcome">{t("welcome")}, {user?.full_name}</h1>
      <div className="rbl-org">{user?.email}</div>

      <div className="rbl-stat-grid" style={{ marginTop: 28 }} data-testid="participant-stats">
        <Stat label={t("statWorksheets")} value={`${wsDone}/${ws.length}`} />
        <Stat label={t("statQuizzes")} value={`${qzDone}/${qz.length}`} />
        <Stat label={t("statReflections")} value={refs.length} />
      </div>

      <div className="rbl-grid" style={{ marginTop: 28 }}>
        <Link to="/app/part1" className="rbl-card" data-testid="dash-link-part1">
          <span className="rbl-card-emoji">📚</span>
          <span className="rbl-card-title">{t("p1Title")}</span>
          <span className="rbl-card-meta">{t("p1Intro")}</span>
        </Link>
        {part2 && (
          <Link to="/app/part2" className="rbl-card" data-testid="dash-link-part2">
            <span className="rbl-card-emoji">🚀</span>
            <span className="rbl-card-title">{t("p2Title")}</span>
            <span className="rbl-card-meta">{t("p2Intro")}</span>
          </Link>
        )}
        <Link to="/app/worksheets" className="rbl-card" data-testid="dash-link-worksheets">
          <span className="rbl-card-emoji">📝</span>
          <span className="rbl-card-title">{t("cardWsTitle")}</span>
          <span className="rbl-card-meta">{t("cardWsDesc")}</span>
        </Link>
        <Link to="/app/quizzes" className="rbl-card" data-testid="dash-link-quizzes">
          <span className="rbl-card-emoji">✅</span>
          <span className="rbl-card-title">{t("cardQzTitle")}</span>
          <span className="rbl-card-meta">{t("cardQzDesc")}</span>
        </Link>
        <Link to="/app/journal" className="rbl-card" data-testid="dash-link-journal">
          <span className="rbl-card-emoji">📓</span>
          <span className="rbl-card-title">{t("cardJrTitle")}</span>
          <span className="rbl-card-meta">{t("cardJrDesc")}</span>
        </Link>
      </div>

      <div className="rbl-feature" style={{ marginTop: 28 }}>
        <h3>📘 {t("journeyTitle")}</h3>
        <p>{t("journeyDesc")}</p>
        <button className="rbl-btn" onClick={downloadJourney} disabled={busy} data-testid="download-journey">
          {busy ? t("journeyBuilding") : t("journeyBtn")}
        </button>
      </div>
    </PLayout>
  );
}
